// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 444) return "app-launcher/444.dc6bd73d7c71377739a7.js";
	if (chunkId === 63) return "app-launcher/63.c43925cbb4070c7378eb.js";
	// return url for filenames based on template
	return undefined;
};